export type GroupOptions = 'all' | 'conversations' | 'task'

export type TypeOptions = 'all' | 'unread' | 'mentions' | 'cleared'

const applySearch = (search: string, notifications: APINotification[]) => {
  const searchTerm = search.trim().toLocaleLowerCase()

  if (searchTerm.length === 0) {
    return notifications
  }

  return notifications.filter(notification => {
    const { title, body } = notification
    const searchable = [title, body]
    return searchable.some(val =>
      (val ?? '').trim().toLocaleLowerCase().includes(searchTerm)
    )
  })
}

const filterGroups = (
  group: GroupOptions,
  notifications: APINotification[]
) => {
  if (group === 'all') {
    return notifications
  }

  return notifications.filter(notification => {
    if (group === 'task') {
      return notification.source === 'task'
    } else {
      return notification.source === 'event' && notification.type === 'mention'
    }
  })
}

const filterTypes = (type: TypeOptions, notifications: APINotification[]) => {
  if (type === 'all') {
    return notifications
  }

  return notifications.filter(notification => {
    const isUnread = notification.read === null
    const isMention =
      notification.source === 'event' && notification.type === 'mention'

    if (type === 'unread') {
      return isUnread
    } else if (type === 'mentions') {
      return isUnread && isMention
    } else {
      return typeof notification.read === 'string' && notification.read
    }
  })
}

const notificationSort = (a: APINotification, b: APINotification) =>
  +new Date(b.stamp) - +new Date(a.stamp)

export const filterNotifications = ({
  notifications,
  group = 'all',
  type = 'all',
  search = ''
}: {
  notifications: APINotification[]
  group: GroupOptions
  type: TypeOptions
  search: string
}) => {
  const searchFiltered = applySearch(search, notifications)
  const groupFiltered = filterGroups(group, searchFiltered)
  const typeFiltered = filterTypes(type, groupFiltered)
  const sorted = typeFiltered.sort(notificationSort)
  return sorted
}
